import { api } from "@/api";

export const deleteBettingSelection = async (id: number): Promise<void> => {
  await api.client.delete(`/betting-selections-new/${id}`);
};
